module.exports = __webpack_public_path__ + "static/media/dxdao.ccd8a72b.svg";